import { useFeatureFlag } from '@client/hooks/useFeatureFlag';
import { redirectIfUnsupportedBrowser } from '@client/utils/browser/browserUtils';
import { useEffect } from 'react';

/**
 * Hook to check browser compatibility
 * Redirects to not-supported page if browser is not supported
 */
export function useBrowserCompatibility() {
    const disableUnsupportedBrowserDetection = useFeatureFlag('disable-unsupported-browser-detection');
    useEffect(() => {
        if (!disableUnsupportedBrowserDetection) {
            redirectIfUnsupportedBrowser();
        }
    }, [disableUnsupportedBrowserDetection]);
}
